var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { Grid } from '@app/Components/Grid/Grid';
import { Column } from 'devextreme-react/data-grid';
import { GateRecommendationDecisionPicker } from '@app/Components/GateRecommendationDecisionPicker/GateRecommendationDecisionPicker';
import { Api } from '@app/Api';
import { Button } from '@app/Components/Button/Button';
import { observer } from 'mobx-react';
import { observable, action } from 'mobx';
import { GateRecommendationDecisionEnum, StatusEnum, GateProcessTypeEnum, SignalREvents } from '@app/AppConstants';
import styles from './RecomendationTable.module.scss';
import { signalRService } from '@app/Services/SignalRService';
import { Modal } from '@app/Components/Modal/Modal';
import { withRouter } from 'react-router-dom';
import DownloadService from '@app/Services/DownloadService';
import { ConfirmationDialog } from '@app/Widgets/ConfirmationDialog/ConfirmationDialog';
var RecomendationTableC = /** @class */ (function (_super) {
    __extends(RecomendationTableC, _super);
    function RecomendationTableC() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._isTemplateLoading = false;
        _this._isAssessmentSentLoading = false;
        _this._isRecomendationLoading = false;
        _this._isGenerateEmailErrorModalOpen = false;
        _this._generateEmailError = '';
        _this._isFreezeCurrentStateOfAssessmentModalOpen = false;
        return _this;
    }
    RecomendationTableC.prototype._toggleGenerateEmailErrorModal = function () {
        this._isGenerateEmailErrorModalOpen = !this._isGenerateEmailErrorModalOpen;
    };
    RecomendationTableC.prototype._toggleFreezeCurrentStateOfAssessmentModalOpen = function () {
        this._isFreezeCurrentStateOfAssessmentModalOpen = !this._isFreezeCurrentStateOfAssessmentModalOpen;
    };
    RecomendationTableC.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._loadRecomendation()];
                    case 1:
                        _a.sent();
                        signalRService.subscribe(SignalREvents.actionItemsChanged, this._loadRecomendation);
                        return [2 /*return*/];
                }
            });
        });
    };
    RecomendationTableC.prototype.componentWillUnmount = function () {
        signalRService.unsubscribe(SignalREvents.actionItemsChanged, this._loadRecomendation);
    };
    RecomendationTableC.prototype._updateDesision = function (desission) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this._recommendation && desission && this._recommendation.decision !== desission)) return [3 /*break*/, 3];
                        return [4 /*yield*/, Api.secured.updateRecommendationDecision(this._recommendation.id, {
                                decision: desission
                            })];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this._loadRecomendation()];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    RecomendationTableC.prototype._approveDecision = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this._isAssessmentSentLoading = true;
                        this.forceUpdate();
                        if (!this._recommendation) return [3 /*break*/, 3];
                        return [4 /*yield*/, Api.secured.approveRecommendation(this._recommendation.id)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this._loadRecomendation()];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        this._isAssessmentSentLoading = false;
                        this._toggleFreezeCurrentStateOfAssessmentModalOpen();
                        return [2 /*return*/];
                }
            });
        });
    };
    RecomendationTableC.prototype._downloadEmailTemplate = function () {
        return __awaiter(this, void 0, void 0, function () {
            var message, data, fileName, _error_1, error;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this._isTemplateLoading = true;
                        this.forceUpdate();
                        if (!this._recommendation) return [3 /*break*/, 5];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, Api.securedWithoutErrorHandler.downloadEmailTemplate(this._recommendation.id)];
                    case 2:
                        message = _a.sent();
                        return [4 /*yield*/, message.blobBody];
                    case 3:
                        data = _a.sent();
                        fileName = "email".concat(this._recommendation.id, ".eml");
                        DownloadService.downloadByData(data, fileName);
                        return [3 /*break*/, 5];
                    case 4:
                        _error_1 = _a.sent();
                        error = _error_1;
                        this._generateEmailError = error.response.data.error;
                        this._isTemplateLoading = false;
                        this._toggleGenerateEmailErrorModal();
                        return [3 /*break*/, 5];
                    case 5:
                        this._isTemplateLoading = false;
                        this.forceUpdate();
                        return [2 /*return*/];
                }
            });
        });
    };
    RecomendationTableC.prototype._loadRecomendation = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, , 2, 3]);
                        this._isRecomendationLoading = true;
                        _a = this;
                        return [4 /*yield*/, Api.secured.getRecommendation({ gateId: this.props.gateId })];
                    case 1:
                        _a._recommendation = _b.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        this._isRecomendationLoading = false;
                        return [7 /*endfinally*/];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    RecomendationTableC.prototype._handleGoToMeetingClick = function () {
        var _a = this.props, history = _a.history, gateId = _a.gateId, projectCodeName = _a.projectCodeName;
        history.push("/projects/".concat(projectCodeName, "/gate-meeting/g-").concat(gateId, "/meeting"));
    };
    RecomendationTableC.prototype.render = function () {
        var _this = this;
        var isProjectTerminatedOrCompleted = this.props.isProjectTerminatedOrCompleted;
        return (React.createElement(React.Fragment, null,
            React.createElement(Grid, { dataSource: [this._recommendation], loading: this._isRecomendationLoading },
                React.createElement(Column, { caption: "Gate", dataField: "gateName", width: 100, allowEditing: false, alignment: "center" }),
                React.createElement(Column, { caption: "Master Checklist", dataField: "masterCheckListCode", width: 150, allowEditing: false, alignment: "center" }),
                React.createElement(Column, { caption: "Recommendation", allowEditing: false, width: 380, cellRender: function (_a) {
                        var _b;
                        var data = _a.data;
                        return (React.createElement(GateRecommendationDecisionPicker, { disabled: ((_b = _this._recommendation) === null || _b === void 0 ? void 0 : _b.status) !== StatusEnum.Draft ||
                                !data.canPrincipalUpdateDecision ||
                                isProjectTerminatedOrCompleted, recommendationId: data.id, gateId: _this.props.gateId, gateProcessType: GateProcessTypeEnum.GateAssessment, defaultValue: data.decision, onChangeHandler: function (d) { return _this._updateDesision(d.value); } }));
                    } }),
                React.createElement(Column, { caption: "Status", dataField: "status", width: 200, allowEditing: false, alignment: "center" }),
                React.createElement(Column, { caption: "Actions", minWidth: 320, allowEditing: false, cellRender: function (_a) {
                        var data = _a.data;
                        return data.decision != GateRecommendationDecisionEnum.NotSpecified &&
                            data.status === StatusEnum.Draft &&
                            data.canPrincipalUpdateDecision ? (React.createElement("div", { className: styles.actions },
                            React.createElement(React.Fragment, null,
                                React.createElement(Button, { size: "sm", color: "primary", className: styles.action, disabled: _this._isTemplateLoading ||
                                        _this._isAssessmentSentLoading ||
                                        isProjectTerminatedOrCompleted, isLoading: _this._isTemplateLoading, onClick: function () { return _this._downloadEmailTemplate(); } }, "Generate Email"),
                                React.createElement(Button, { size: "sm", color: "primary", className: styles.action, onClick: _this._toggleFreezeCurrentStateOfAssessmentModalOpen, disabled: _this._isTemplateLoading ||
                                        _this._isAssessmentSentLoading ||
                                        isProjectTerminatedOrCompleted, isLoading: _this._isAssessmentSentLoading }, "Freeze current state of assessment")))) : null;
                    } })),
            React.createElement(Modal, { isOpen: this._isGenerateEmailErrorModalOpen, toggle: this._toggleGenerateEmailErrorModal, headerTitle: "Error", footerbuttons: this._getFooterButtons() }, this._generateEmailError),
            React.createElement(ConfirmationDialog, { isOpen: this._isFreezeCurrentStateOfAssessmentModalOpen, onToggle: this._toggleFreezeCurrentStateOfAssessmentModalOpen, headerTitle: 'Freeze current state of assessment', onSave: function () { return _this._approveDecision(); }, body: 'Would you really want to freeze the current state of assessment? \nAll deliverables and checklists can’t be modified anymore.' })));
    };
    RecomendationTableC.prototype._getFooterButtons = function () {
        return [
            {
                color: 'success',
                onClick: this._handleGoToMeetingClick,
                title: 'Go To Meeting'
            },
            {
                onClick: this._toggleGenerateEmailErrorModal,
                title: 'Close'
            }
        ];
    };
    __decorate([
        observable
    ], RecomendationTableC.prototype, "_recommendation", void 0);
    __decorate([
        observable
    ], RecomendationTableC.prototype, "_isTemplateLoading", void 0);
    __decorate([
        observable
    ], RecomendationTableC.prototype, "_isAssessmentSentLoading", void 0);
    __decorate([
        observable
    ], RecomendationTableC.prototype, "_isRecomendationLoading", void 0);
    __decorate([
        observable
    ], RecomendationTableC.prototype, "_isGenerateEmailErrorModalOpen", void 0);
    __decorate([
        observable
    ], RecomendationTableC.prototype, "_generateEmailError", void 0);
    __decorate([
        observable
    ], RecomendationTableC.prototype, "_isFreezeCurrentStateOfAssessmentModalOpen", void 0);
    __decorate([
        action.bound
    ], RecomendationTableC.prototype, "_toggleGenerateEmailErrorModal", null);
    __decorate([
        action.bound
    ], RecomendationTableC.prototype, "_toggleFreezeCurrentStateOfAssessmentModalOpen", null);
    __decorate([
        action.bound
    ], RecomendationTableC.prototype, "_loadRecomendation", null);
    __decorate([
        action.bound
    ], RecomendationTableC.prototype, "_handleGoToMeetingClick", null);
    RecomendationTableC = __decorate([
        observer
    ], RecomendationTableC);
    return RecomendationTableC;
}(React.PureComponent));
export var RecomendationTable = withRouter(RecomendationTableC);
